import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../globalcomponents/navbar/NavbarTwo";
import ProductListFour from "../productlisting/ListProducts/ProductListFour";
import ProductListOne from "../productlisting/ListProducts/ProductListOne";
import ProductListThree from "../productlisting/ListProducts/ProductListThree";
import ProductListTwo from "../productlisting/ListProducts/ProductListTwo";
import SellerFilters from "./SellerFilters";

const SellerListing = () => {
  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container">
          <div className="d-flex mt-0">
            <div className="border-end custom-wid-1 h-auto justify-content-center text-start h-auto w-15">
              <div>
                <SellerFilters />
              </div>
            </div>
            <div>
              <div className=" mt-5 mb-2 px-5">
                <div className=" d-flex justify-content-between align-items-center text-start">
                  <div className=" w-100">
                    <div className=" lh-0 mb-3">
                      <h2 className=" text-black fw-normal">Cocoblu Retail</h2>
                    </div>
                    <div>
                      <span>
                        {" "}
                        <i className="bi bi-star-fill text-yellow"></i>
                        <i className="bi bi-star-fill text-yellow ms-1"></i>
                        <i className="bi bi-star-fill text-yellow ms-1"></i>
                        <i className="bi bi-star-fill text-yellow ms-1"></i>
                        <i className="bi bi-star-fill text-yellow ms-1"></i>
                      </span>{" "}
                      &nbsp; | &nbsp;{" "}
                      <b className=" text-black text-sm">93% positive</b>{" "}
                      <b className=" text-black fw-normal text-sm">
                        in the last 12 months (114082)
                      </b>
                      ratings)
                    </div>
                  </div>
                  <div className=" w-100"></div>
                </div>
              </div>
              <hr className=" horizontal dark" />
              <div className="row container mx-auto mt-2 mb-3">
                <b className="fw-bold text-2xl text-black ms-3">
                  Related to your recent views
                </b>
                <ProductListOne />
              </div>
              <div className="row container mx-auto mt-2 mb-3">
                <b className="fw-bold text-2xl text-black ms-3">
                  Popular Products
                </b>
                <ProductListTwo />
              </div>
              <div className="row container mx-auto mt-2 mb-3">
                <b className="fw-bold text-2xl text-black ms-3">
                  Top Discounted Products
                </b>
                <ProductListThree />
              </div>
              <div className="row container mx-auto mt-2 mb-3">
                <b className="fw-bold text-2xl text-black ms-3">
                  Explore Top Deals
                </b>
                <ProductListFour />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href="/DetailPage">
                <i className="ri-arrow-left-s-line fs-3 me-1 text-black"></i>
              </a>
            </li>
          </div>
          <div className=" d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <div className=" pt-6 mb-2 px-3">
          <div className=" card mx-auto border-radius-lg shadow p-2">
            <div className=" d-flex justify-content-between align-items-center px-2">
              <div className=" w-100">
                <div className=" lh-0 mb-3">
                  <h2 className=" text-black fw-normal">Cocoblu Retail</h2>
                </div>
                <div>
                  <span>
                    {" "}
                    <i className="bi bi-star-fill text-yellow"></i>
                    <i className="bi bi-star-fill text-yellow ms-1"></i>
                    <i className="bi bi-star-fill text-yellow ms-1"></i>
                    <i className="bi bi-star-fill text-yellow ms-1"></i>
                    <i className="bi bi-star-fill text-yellow ms-1"></i>
                  </span>{" "}
                  &nbsp; | &nbsp;{" "}
                  <b className=" text-black text-sm">93% positive</b>{" "}
                  <b className=" text-black fw-normal text-sm">
                    in the last 12 months (114082)
                  </b>
                  ratings)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="px-2 mt-2 mb-3">
          <b className="fw-bold text-lg text-black ms-3">
            Related to your recent views
          </b>
          <div className=" mt-2">
            <ProductListOne />
          </div>
        </div>
        <div className="px-2 mt-4 mb-3">
          <b className="fw-bold text-lg text-black ms-3">Popular Products</b>
          <div className=" mt-2">
            <ProductListTwo />
          </div>
        </div>
        <div className="px-2 mt-4 mb-3">
          <b className="fw-bold text-2xl text-black ms-3">
            {" "}
            Top Discounted Products
          </b>
          <div className=" mt-2">
            <ProductListThree />
          </div>
        </div>
        <div className="px-2 mt-4 mb-3">
          <b className="fw-bold text-lg text-black ms-3"> Explore Top Deals</b>
          <div className=" mt-2">
            <ProductListFour />
          </div>
        </div>
      </div>
    </>
  );
};

export default SellerListing;
